// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';

import React from 'react';
import { Item2TitleData } from '@reverbdotcom/commons/src/gql/graphql';
import ConditionDisplay from '@reverbdotcom/commons/src/components/condition_display';
import BestSellerBadge from './best_seller_badge';

interface IProps {
  listing: Item2TitleData.Fragment;
}

export const Item2TitleFragment = gql`
  fragment Item2TitleData on Listing {
    _id
    id
    title
    condition {
      conditionSlug
      displayName
    }
    categories {
      _id
      id
      slug
      name
      rootSlug
    }
    csp {
      _id
      id
    }
  }
`;

export function Item2Title({ listing }: IProps) {
  if (!listing) return null;

  return (
    <div className="item2-title">
      <div className="item2-title__inner">
        <h1>
          {listing.title}
        </h1>
        <ConditionDisplay
          slug={listing.condition.conditionSlug}
          displayName={listing.condition.displayName}
          showTooltip
          textOnly
          displayAsTag
        />
        <BestSellerBadge
          cspId={listing?.csp?.id}
          listingId={listing?.id}
          categories={listing?.categories}
        />
      </div>
    </div>
  );
}
